import type { LocalizedList, LocalizedText } from "./types";

export const LOCALES = ["de", "en"] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "de";
export const LOCALE_COOKIE = "NEXT_LOCALE";

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (LOCALES as readonly string[]).includes(value);
}

/** Pick the text for `locale`, falling back to German, English or anything. */
export function lt(text: LocalizedText | null | undefined, locale: string): string {
  if (!text) return "";
  return text[locale] || text.de || text.en || Object.values(text).find(Boolean) || "";
}

export function ll(list: LocalizedList | null | undefined, locale: string): string[] {
  if (!list) return [];
  const pick = list[locale]?.length ? list[locale] : list.de?.length ? list.de : list.en;
  return pick ?? Object.values(list).find((l) => l?.length) ?? [];
}

/** Update one language of a localized text, keeping the others. */
export function setLt(text: LocalizedText, locale: string, value: string): LocalizedText {
  return { ...text, [locale]: value };
}
